import React from 'react'
import {inject} from "mobx-react"
import PropTypes from "prop-types"

import About from "../components/complex/About"

@inject(stores => ({
    nav: stores.navigation_store
}))
class AboutPage extends React.Component {

    constructor(props) {
        super(props)
        props.nav.setActiveScreen("about")
    }

    render(){
        return (
            <About />
        )
    }

}

AboutPage.wrappedComponent.propTypes = {
    nav: PropTypes.object.isRequired
}

export default AboutPage


// WEBPACK FOOTER //
// ./src/pages/about.js